import React from 'react';
import { handleMessage } from '../../utils/handleMessage';
import { Container, Content, CenterData } from './styles';
import { Button } from '..';

type PopupProps = {
    message: string;
    description?: string;
    parameters?: object[];
    handleOk: () => void;
}

const Popup: React.FC<PopupProps> = ({ message, description, parameters = [], handleOk }) => {
    return (
        <Container>
            <Content>
                <CenterData>
                    <h5>{handleMessage(message, parameters)}</h5>
                    <span>{description}</span>
                </CenterData>
                <Button
                    id="popup.okbutton"
                    onClick={handleOk}
                >
                    Ok
                </Button>
            </Content>
        </Container>
    );
};

export { Popup };
export type { PopupProps };